import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { duration } from 'moment';
import { DataLoadingService } from 'src/app/shared/services/data-loading.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { Messages } from 'src/app/shared/Validations/messages';
import { constants } from '../../shared/common/contants';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog } from '@angular/material/dialog';
import { MasterDataLoadLogPopupComponent } from 'src/app/user/master-data-load-log-popup/master-data-load-log-popup.component';
import { EtlService } from 'src/app/user/vault-data-migration-etl/etl.service'
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';

@Component({
    selector: 'app-baseline-data-load',
    templateUrl: './baseline-data-load.component.html',
    styleUrls: ['./baseline-data-load.component.scss'],
    standalone: false
})
export class BaselineDataLoadComponent implements OnInit {

  gridAPI;
  onBtExport;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;

  backgroundColorButton = "";

  loading = false;
  loading1 = false;
  loading2 = false;

  extractLogFileUrl: any;
  convertLogFileUrl: any;
  uploadLogFileUrl: any;

  masterDataLoadLogObject: any = [];

  displayData: boolean = false;

  columnDefsFullDataLoad;
  gridApi;
  gridApiData;

  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private dataLoadService: DataLoadingService,
    private constants: constants,
    private snackbar: MatSnackBar,
    private msg: Messages,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private etlService: EtlService
  ) {
    this.components = {
      downloadbuttonRenderer: FiledownloadComponent
    }
   }

  ngOnInit() {

    this.columnDefs = [
      { headerName: 'Object', headerTooltip: 'Object', tooltipValueGetter: (params) => 'Object : ' + params.value, field: 'object', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Download Log File', headerTooltip: 'Download Log File', tooltipValueGetter: (params) => 'Download Log File : ' + params.value, field: 'downloadlogfile', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Log Description', headerTooltip: 'Log Description', tooltipValueGetter: (params) => 'Log Description : ' + params.value, field: 'logdescription', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Date & Time', headerTooltip: 'Date & Time', tooltipValueGetter: (params) => 'Date & Time : ' + params.value, field: 'dateandtime', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 180 }
    ];

    this.columnDefsFullDataLoad=[
      { headerName: 'Run Id', headerTooltip: 'Run Id', tooltipValueGetter: (params) => 'Run Id : ' + params.value, field: 'runid', filter: 'agTextColumnFilter', width: 80 },
      { headerName: 'Activity', headerTooltip: 'Activity', tooltipValueGetter: (params) => 'Activity : ' + params.value, field: 'activityname', filter: 'agTextColumnFilter', width: 100 },
      { headerName: 'Current State', headerTooltip: 'Current State', tooltipValueGetter: (params) => 'Current State : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 100 },
      { headerName: 'Extraction Start Date Time', headerTooltip: 'Extraction Start Date Time', tooltipValueGetter: (params) => 'Extraction Start Date Time: ' + params.value, field: 'extractionstartdt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Extraction End Date Time', headerTooltip: 'Extraction End Date Time', tooltipValueGetter: (params) => 'Extraction End Date Time: ' + params.value, field: 'extractionenddt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Convert Start Date Time', headerTooltip: 'Convert Start Date Time', tooltipValueGetter: (params) => 'Convert Start Date Time: ' + params.value, field: 'convertstartdt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Convert End Date Time', headerTooltip: 'Convert End Date Time', tooltipValueGetter: (params) => 'Convert End Date Time: ' + params.value, field: 'convertenddt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Load Start Date Time', headerTooltip: 'Load Start Date Time', tooltipValueGetter: (params) => 'Load Start Date Time: ' + params.value, field: 'loadstartdt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Load End Date Time', headerTooltip: 'Load End Date Time', tooltipValueGetter: (params) => 'Load End Date Time: ' + params.value, field: 'loadenddt', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Extraction Log File',filter: false, cellRenderer: 'downloadbuttonRenderer',
        headerTooltip:'Download Extraction Log',
        cellRendererParams: {
        docdownload: this.downloadExtractionLog.bind(this),
      }, width: 180 }
    ]

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    this.retrieveMasterDataLoadLog();

  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  // onGridReady(params) {
  //   let res: any
  //   this.gridAPI = params.api;
  //   this.gridColumnAPI = params.columnApi;
  // }

  extract() {
    this.loading = true;
    this.dataLoadService.extractService().subscribe(res => {
      if (res.error) {
        this.loading = false;
        return this.snackbar.open(res.statusMessage, "Ok", {
          duration: 5000
        });
      } else {
        this.loading = false;
        console.log(res);
        this.extractLogFileUrl = res;
      }
    }, () => {
      this.loading = false;
      this.snackbar.open(this.msg.appStaticMessages.CHECKCONNECTION, 'Ok', {
        duration: 5000
      });
    });
  }

  convert() {
    this.loading1 = true;
    this.dataLoadService.convertService().subscribe(res => {
      if (res.error) {
        this.loading1 = false;
        return this.snackbar.open(res.statusMessage, "Ok", {
          duration: 5000
        });
      } else {
        this.loading1 = false;
        console.log(res);
        this.convertLogFileUrl = res;
      }
    }, () => {
      this.loading1 = false;
      this.snackbar.open(this.msg.appStaticMessages.CHECKCONNECTION, 'Ok', {
        duration: 5000
      });
    });
  }

  loadToS3() {
    this.loading2 = true;
    this.dataLoadService.loadToS3Service().subscribe(res => {
      if (res.error) {
        this.loading2 = false;
        return this.snackbar.open(res.statusMessage, "Ok", {
          duration: 5000
        });
      } else {
        this.loading2 = false;
        console.log(res);
        this.uploadLogFileUrl = res;
      }
    }, () => {
      this.loading2 = false;
      this.snackbar.open(this.msg.appStaticMessages.CHECKCONNECTION, 'Ok', {
        duration: 5000
      });
    });
  }

  retrieveMasterDataLoadLog() {

    this.spinner.start();

    this.dataLoadService.retrieveMasterDataLoadLogService().subscribe(response => {
      console.log(response)

      // Removed if condition which was not needed it was checking for error response.

        this.masterDataLoadLogObject = response;

        console.log("this.masterDataLoadLogObject");

        console.log(this.masterDataLoadLogObject);

        console.log(this.masterDataLoadLogObject.length == 3);

        if (this.masterDataLoadLogObject.length == 3) {

          this.displayData = true;

        }

        this.spinner.stop();

    });

  }

  extractConvertLoad() {

    let width = "40%";

    let dialogRef = this.dialog.open(MasterDataLoadLogPopupComponent, {
      maxWidth: '100vw',
      width: width,
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      console.log(result == "Yes");

      if (result == "Yes") {

        this.dataLoadService.extractConvertLoadService(this.localStorageSettings.getSettings("vaultDnsname")).subscribe(response => {

          console.log(response);

          this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });

          this.spinner.stop();

        });

      }

    });

  }


  async onGridReadyFullData(params) {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.spinner.start()
    this.dataLoadService.retrieveMasterDataLoadService().subscribe(res=>
    {

      if (res.error) {

        this.snackbar.open(res.statusMessage, "Ok", {
          duration: 5000
        });
        this.spinner.stop();
      } else {


        this.gridAPI.setGridOption('rowData', res);
        this.spinner.stop();

      }


    })
  }
  extractionLogPath
  downloadExtractionLog(e){
    console.log(e.rowData)
    this.extractionLogPath = e.rowData.extactionlogfilepath
    console.log(e.rowData.extractionLogPath)
    if(this.extractionLogPath===undefined || this.extractionLogPath=== "" || this.extractionLogPath ===null){
      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.extractionLogPath.split('/').pop()
      let data = {
        s3Path:this.extractionLogPath,
      };
      this.etlService.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }

}
